import { observer } from 'mobx-react-lite'
import { PropsWithChildren, useEffect } from 'react'
import { useAccount } from 'wagmi'
import { useAuth } from '../../../hooks/useAuth'
import usePrevious from '../../../hooks/usePrevious'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { Box } from '../../core/Components'
import { Layout } from '../../internal/components/Layout'

const InternalRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const { silentLogin, logout, user, isLoggingIn } = useAuth()
  const { address: walletAddress } = useAccount()
  const previousWalletAddress = usePrevious(walletAddress)
  const prevIsLoggingIn = usePrevious(isLoggingIn)

  // Must be an auth'd user to access the internal dash, so we can auto log them in
  useEffect(() => {
    silentLogin()
  }, [walletAddress])

  useEffect(() => {
    if (previousWalletAddress !== undefined && previousWalletAddress !== walletAddress) {
      // currently we are just logging out users if they try to switch accounts
      logout()
    }
  }, [previousWalletAddress, walletAddress])

  useEffect(() => {
    if ((!user && !isLoggingIn && prevIsLoggingIn !== undefined) || user?.type === 'normal') {
      // Must use window directly since multiple react router entry points for the app
      window.location.replace('/')
    }
  }, [user, isLoggingIn, prevIsLoggingIn])

  if (isLoggingIn || !user) {
    return (
      <Box css={{ minHeight: '100vh', display: 'flex', justifyContent: 'center' }}>
        <CenteredLoadingAnimation />
      </Box>
    )
  }

  if (user?.type === 'normal') {
    return null
  }

  return <Layout>{children}</Layout>
}

export default observer(InternalRoute)
